import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
require("./assets/lhm-image-box.css");
require("./assets/lhmEditor.bootstrap.css");

createApp(App).use(store).use(router).mount('#app')
